import React, { ReactElement } from 'react';
import FormatService from '../../services/format-service';
import FlexContainer from '../flex-container/flex-container.component';
import useStylesFieldAddressBlock from './field-address-block.styles';

const FieldAddressBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isInline,
    isCompressed,
    withOffset,
    className,
    children,
  } = props;

  const { classes } = useStylesFieldAddressBlock();

  const defaultClassName: string | undefined = !isCompressed ? classes.fieldAddressBlockDefault : undefined;
  const compressedClassName: string | undefined = isCompressed ? classes.fieldAddressBlockCompressed : undefined;
  const inlineClassName: string | undefined = isInline ? classes.fieldAddressBlockInline : undefined;
  const offsetClassName: string | undefined = withOffset && !isCompressed
    ? classes.fieldAddressBlockOffset : undefined;
  const offsetCompressedClassName: string | undefined = withOffset && isCompressed
    ? classes.fieldAddressBlockOffsetCompressed : undefined;

  return (
    <FlexContainer
      className={FormatService.formatClassNames(
        classes.fieldAddressBlock, defaultClassName, compressedClassName, inlineClassName,
        offsetClassName, offsetCompressedClassName, className,
      )}
    >
      {children}
    </FlexContainer>
  );
});

export default FieldAddressBlock;
